<template>
    <UiModal title="Eroare dispozitive media" 
        subtitle="Informații utile" 
        :buttons="buttons" 
        :actionForceWrap="true"
        @retry="retry" 
        @continue="$emit('close')" 
        @close="$emit('close')">

        <template slot="body">
            <div class="content__heading content__heading--center">
                Nu au fost detectate <span>dispozitive media</span>!
            </div>
            <div class="content content--center"> 
                Din pacate nu am reusit sa accesam microfonul sau camera web.</br></br>
                Asigurati-va ca dispozitivele dvs. sunt conectate si ca browserul web de pe care accesati platforma <span>NEXYO</span> are toate permisiunile necesare.</br></br>
                Vizitati pagina <span class="link" @click="gotoHelpPage()">testare dispozitive</span> pentru mai multe detalii.
            </div>
            <div class="hide-mobile">
                <div class="content__line"></div>
                <div class="content__info">
                    *Chat-ul este in continuare disponibil pentru a comunica cu specialistul dvs. !
                </div>
            </div>
        </template>
    </UiModal>
</template>
<script>
import UiModal from "@/components/ui/Modal";

export default {
  components: {
    UiModal,
  },
  data: function () {
    return {
      buttons: [
        {
          event: "retry",
          text: "Reîncearcă conectarea",
          style: "gradient",
        },
        {
          event: "continue",
          text: "Continuă fară audio/video",
        },
      ],
    };
  },
  methods:{
      gotoHelpPage: function (){
          this.$router.push('/help');
          location.reload();
      },
      retry(){
        this.$router.push({
            path: this.$router.currentRoute.path,
            query: {
            token: this.$router.currentRoute.query.token,
            joinVideo: 'true'
        }
        });
        location.reload();
      }
  }
};
</script>
<style lang="scss" scoped>
.content__info {
  margin-bottom: 10px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>